import { Dialog, useDialogManager } from '../../widgets/dialog';
import React, { FC, Suspense } from 'react';
import { Loader } from '../../../shared/docsDialog';
import ApiKeys from '../myAccount/apiKeys';

interface ApiKeyDialogProps {
    salesChannelID: string;
}

const ApiKeyDialog: FC<ApiKeyDialogProps> = ({ salesChannelID }) => {
    const { closeDialog } = useDialogManager();

    return (
        <Dialog title='API Keys' onClose={() => closeDialog('api-key')}>
            <Suspense fallback={Loader}>
                <ApiKeys salesChannelID={salesChannelID} />
            </Suspense>
        </Dialog>
    );
};

export default ApiKeyDialog;
